module.exports = __webpack_public_path__ + "static/cheif-information@2x-9f30ac69052e31fc6f199294b8cb964c.jpg";